/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliSavePeriodGradeDto } from '../../models/amoxcalli-save-period-grade-dto';

export interface ApiGradesPeriodGet$Json$Params {
  cycleSubjectId?: string;
  periodId?: string;
  groupId?: string;
}

export function apiGradesPeriodGet$Json(http: HttpClient, rootUrl: string, params?: ApiGradesPeriodGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliSavePeriodGradeDto>>> {
  const rb = new RequestBuilder(rootUrl, apiGradesPeriodGet$Json.PATH, 'get');
  if (params) {
    rb.query('cycleSubjectId', params.cycleSubjectId, {});
    rb.query('periodId', params.periodId, {});
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliSavePeriodGradeDto>>;
    })
  );
}

apiGradesPeriodGet$Json.PATH = '/api/grades/period';
